export default __webpack_public_path__ + "static/media/Bridesmaids.3f48fc56.webm";